import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import MeetingAgendaCard from '../MeetingAgendaCard';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  scheduledMessagesHeader: {
    padding: theme.spacing(2, 3),
    display: 'flex',
    flexDirection: 'column',
  },
  scheduledMessagesContainer: {
    padding: theme.spacing(2, 3),
  },
});

const ScheduledMessagesList = ({
  className,
  classes,
  scheduledMessages,
  refreshScheduledMessages,
  eventTrackingLogEventProps,
}) => {
  const hasScheduledMessages = scheduledMessages.resources().list().length >= 1;

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <div className={classes.scheduledMessagesHeader}>
        <Typography
          color="primary"
          variant="h2"
          weight={'bold'}
        >
          {'Scheduled Messages'}
        </Typography>
        {!hasScheduledMessages && (
          <Typography
            color="primary"
          >
            {'You have no scheduled messages. Once you do, they will appear here.'}
          </Typography>)
        }
      </div>
      {hasScheduledMessages && (
        <div className={classes.scheduledMessagesContainer}>
          {scheduledMessages.resources().list().map(scheduledMessage => (
            <MeetingAgendaCard
              meetingAgendaResource={scheduledMessage}
              refreshCollection={refreshScheduledMessages}
              allowReschedule
              {...eventTrackingLogEventProps}
            />
          ))}
        </div>
      )}
    </Box>
  );
};

ScheduledMessagesList.defaultProps = {
  className: '',
};

ScheduledMessagesList.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  scheduledMessages: PropTypes.array.isRequired,
  refreshScheduledMessages: PropTypes.func.isRequired,
  eventTrackingLogEventProps: PropTypes.object.isRequired,
};

export default withStyles(styles)(ScheduledMessagesList);
